
import Swup from 'swup'
import {init as initComponents} from './component'
import {dispatch} from './events'

const componentContext = require.context('../components',true,/\.js$/);
componentContext.keys().forEach(key=>componentContext(key));

let instance = null;

const isDev = process.env.NODE_ENV === 'development';

export default class PageController {
    static get instance(){
        return instance;
    }

    constructor(settings={}){
        instance = this;
        const {el='#page',pageTransitions=true,swupOptions={debugMode: 0/*isDev*/,animateScroll:false}} = settings;
        pageTransitions && this.initSwup(el,swupOptions);
        this.el = el;
        this.init();
    }

    initSwup(el,options={}) {
        this.swup = new Swup({
            ...options,
            elements: [el],
        });
        document.addEventListener('swup:pageView', this.init);
        document.addEventListener('swup:animationInDone', this.dispatchFullyInitialized);
    }

    init = ()=>{
        initComponents(document.querySelector(this.el));
        this.dispatchFullyInitialized();
        this.trackPageView();
    }

    dispatchFullyInitialized = ()=>{
        dispatch(document,"page:fullyInitialized",{time:new Date()});
    }

    trackPageView(){
        if (typeof window.ga === 'function') {
            let title = document.title;
            let url = window.location.pathname + window.location.search;

            window.ga('set', 'title', title);
            window.ga('set', 'page', url);
            window.ga('send', 'pageview');

            this.swup.log(`GA pageview (url '${url}').`);
        } else {
            console.warn('GA is not loaded.');
        }
    }

    destroy(){
        this.swup.destroy();
        document.removeEventListener('swup:pageView', this.init);
    }
}